import { render, staticRenderFns } from "./ResultNotify.vue?vue&type=template&id=2075605d&scoped=true&"
import script from "./ResultNotify.vue?vue&type=script&lang=js&"
export * from "./ResultNotify.vue?vue&type=script&lang=js&"
import style0 from "./ResultNotify.vue?vue&type=style&index=0&id=2075605d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2075605d",
  null
  
)

export default component.exports